import React from 'react';
import './src/styles/global.css';
import { AuthProvider } from './src/contexts/AuthContext';
import ProtectedRoute from './src/components/ProtectedRoute';

export const wrapRootElement = ({ element }) => {
  return <AuthProvider>{element}</AuthProvider>;
};

export const wrapPageElement = ({ element, props }) => {
  // Protect all /gry/ pages - redirect to login if not authenticated
  if (props.location.pathname.startsWith('/gry/') || props.location.pathname === '/gry') {
    return <ProtectedRoute>{element}</ProtectedRoute>;
  }
  return element;
};
